(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["category-grid"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';

  var seen = new WeakSet();
  var requests = new Map();
  var queue = [];
  var active = 0;

  function drain() {
    while (active < 4 && queue.length) {
      active++;
      queue.shift()();
    }
  }

  function newestPhoto(url) {
    if (!requests.has(url)) {
      requests.set(url, new Promise(function (resolve) {
        queue.push(async function () {
          var controller = new AbortController();
          var timer = setTimeout(function () { controller.abort(); }, 8000);
          try {
            var response = await fetch(url, { credentials: 'same-origin', signal: controller.signal });
            if (!response.ok) throw new Error('Category photo unavailable');
            var data = await response.json();
            if (data.sort_by !== 'created-descending') throw new Error('Category sort unavailable');
            resolve(data.image);
          } catch (e) {
            requests.delete(url);
            resolve(null); // Keep the Liquid-rendered photo on failure.
          } finally {
            clearTimeout(timer);
            active--;
            drain();
          }
        });
        drain();
      }));
    }
    return requests.get(url);
  }

  async function updatePhoto(tile) {
    var url = new URL(tile.getAttribute('data-rt-category-photo-url'), window.location.origin);
    var preview = new URLSearchParams(window.location.search).get('preview_theme_id');
    var theme = window.Shopify && window.Shopify.theme;
    if (!preview && theme && theme.role !== 'main') preview = theme.id;
    if (preview && /^\d+$/.test(String(preview))) url.searchParams.set('preview_theme_id', preview);
    var photo = await newestPhoto(url.toString());
    if (!photo || !photo.src || !tile.isConnected) return;
    var container = tile.querySelector('.rt-cat-tile__icon');
    if (!container) return;
    // Preload before replacing the fallback, including its responsive sources.
    var img = new Image();
    img.alt = '';
    img.decoding = 'async';
    img.sizes = '(max-width: 720px) 45vw, 300px';
    img.onload = function () {
      if (tile.isConnected) container.replaceChildren(img);
    };
    img.onerror = function () { /* Keep the fallback when the product image is broken. */ };
    if (photo.width && photo.height) {
      img.width = photo.width;
      img.height = photo.height;
    }
    if (photo.srcset) img.srcset = photo.srcset;
    img.src = photo.src;
  }

  var observer = typeof window.IntersectionObserver === 'function' ? new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (!entry.isIntersecting) return;
      observer.unobserve(entry.target);
      updatePhoto(entry.target);
    });
  }, { rootMargin: '200px' }) : null;

  function init(root) {
    root.querySelectorAll('[data-rt-category-photo-url]').forEach(function (tile) {
      if (seen.has(tile)) return;
      seen.add(tile);
      if (observer) observer.observe(tile);
      else updatePhoto(tile);
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(document); });
  else init(document);
  document.addEventListener('shopify:section:load', function (event) { init(event.target); });
})();

  } catch(e) { console.error(e); }
})();
})();
